import { createAction } from '../../../store.model';
import { ActionType } from '../transcript-import-dialog.action';

export interface SelectUser {
    userId: number;
    name: string;
}

export const selectUser = createAction<ActionType, SelectUser>(
    ActionType.TC__TI__SELECT_USER,
);
